import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

const SimsContext = createContext();

export const useSims = () => useContext(SimsContext);

export const SimsProvider = ({ children }) => {
    // --- POS Cart State (Local Only) ---
    const [posCart, setPosCart] = useState([]);
    
    React.useEffect(() => {
        localStorage.setItem('sims_pos_cart', JSON.stringify(posCart));
    }, [posCart]);

    const addToPosCart = useCallback((product) => {
        if (product) {
            setPosCart(prev => [...prev, product]);
            return true;
        }
        return false;
    }, []);

    const clearPosCart = useCallback(() => setPosCart([]), []);

    // --- Analytics/Dashboard UI State ---
    const [showRevenueChart, setShowRevenueChart] = useState(true);
    const [showSalesPie, setShowSalesPie] = useState(true);

    const addInventoryItem = useCallback(() => {}, []);
    const updateInventoryQuantity = useCallback(() => {}, []);
    const getDatabaseDump = useCallback(() => ({}), []);

    const [role, setRole] = useState('ROLE_ADMIN');

    const value = useMemo(() => ({
        role,
        setRole,
        posCart,
        setPosCart,
        addToPosCart,
        clearPosCart,
        showRevenueChart,
        setShowRevenueChart,
        showSalesPie,
        setShowSalesPie,
        addInventoryItem,
        updateInventoryQuantity,
        getDatabaseDump
    }), [role, posCart, showRevenueChart, showSalesPie, addToPosCart, clearPosCart, addInventoryItem, updateInventoryQuantity, getDatabaseDump]);

    return (
        <SimsContext.Provider value={value}>
            {children}
        </SimsContext.Provider>
    );
};
